import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSmall = (props) => /* @__PURE__ */ _jsxs("g", { children: [
	/* @__PURE__ */ _jsx("polygon", {
		points: "386.16,220.98 277.23,188.56 277.23,411.6 386.16,391.65 ",
		transform: "translate(-154.14,-188.56)"
	}),
	/* @__PURE__ */ _jsx("polygon", {
		points: "386.16,220.98 277.23,188.56 277.23,411.6 386.16,391.65 ",
		transform: "translate(-154.14,-188.56)"
	}),
	/* @__PURE__ */ _jsx("polygon", {
		points: "207.45,335.01 207.45,260.32 154.14,263.68 154.14,328.61 ",
		transform: "translate(-154.14,-188.56)"
	})
] });
export default SvgLogoSmall;
